import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose"; // @flow

import React from 'react';
/*::
import type { Node } from 'react';

export type IconProps = {|
  color?: string,
  width?: number,
  height?: number,
|}
*/

var WDZ = 96.227;
var HGT = 96.227;
var WTH = WDZ / HGT;
var HTW = HGT / WDZ;

var Facebook = function Facebook(_ref
/*: $Rest<IconProps, any> */
) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#1B4473' : _ref$color,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? WDZ / 10 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? HGT / 10 : _ref$height,
      rest = _objectWithoutPropertiesLoose(_ref, ["color", "width", "height"]);

  var w = width * 10 === WDZ ? height * WTH : width;
  var h = height * 10 === HGT ? width * HTW : height;
  /* eslint-disable max-len */

  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 " + WDZ + " " + HGT,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: w + "rem",
      height: h + "rem"
    }
  }, rest), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: color,
    d: "M73.099,15.973l-9.058,0.004c-7.102,0-8.477,3.375-8.477,8.328v10.921h16.938l-0.006,17.106H55.564v43.895H37.897V52.332 h-14.77V35.226h14.77V22.612C37.897,7.972,46.84,0,59.9,0L73.1,0.021L73.099,15.973L73.099,15.973z"
  })));
  /* eslint-enable max-len */
};

export default Facebook;